<script>
import { fabric } from "@vfdp-customs/customs-fabric";
import tinycolor from "tinycolor2/tinycolor";
// SVG IDs that do not need to be recolored. This needs a slodi solution
const SVGPaths = [
  "inner",
  "e1_circleArc",
  "e2_circleArc",
  "e3_circleArc",
  "e5_circleArc",
  "e4_circleArc",
  "e6_circleArc"
];
export default {
  name: "placement-mask",
  inject: ["getCanvas"],
  computed: {
    isSecondPlacement() {
      return this.$store.getters['ugc/tempData/getPlacementViewOrder'] === 1;
    },
    getMultipart() {
      return this.$store.getters["ugc/tempData/checkMultipart"];
    },
    activeUGCIndex() {
      return this.$store.state.ugc.tempData.activeUGCIndex;
    },
    activeUGCComponent() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].activeUGCComponent;
    },
    getSize() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].responses.assets3d[
        this.activeUGCComponent
      ].model.size;
    },
    getPlacementMaskScaleRatio() {
      return this.$store.state.utils.pdm.components[this.activeUGCComponent].ugc
        .default_mask_size[this.getSize];
    },
    getUgcImgUrl() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].ugc_image;
    }
  },
  methods: {
    /**
     * Set the overlay placement into the canvas
     * @public
     */
    setOverlayImage() {
      this.$store.commit("ugc/stateManager/SET_LOADING", true);
      this.$eventBus.$emit("hide-customs-spinner", false);
      const placementViewOrder = this.$store.getters["ugc/tempData/getPlacementViewOrder"];
      const overlaySrc = this.$store.getters["utils/addCacheBusting"](this.getPlacementURL(placementViewOrder));

      this.getCanvas().then(fabricCanvas => {
        new fabric.loadSVGFromURL(overlaySrc, (objects, options) => {
          //show binding area and line on template guide
          objects.forEach(obj => {
            if (obj.id === "binding-line" || obj.id === "binding-visiblearea") {
              obj.set({ visible: "true" });
            }
          });
          const overlaySVG = fabric.util.groupSVGElements(objects, options);
          overlaySVG.set({
            scaleY: this.getPlacementMaskScaleRatio,
            scaleX: this.getPlacementMaskScaleRatio
          });
          const img = new Image();
          img.crossOrigin = "Anonymous";
          img.onload = () => {
            this.$store.dispatch("utils/RETURN_AVERGAGE_RGB", img)
            .then(rgb => this.setNewPlacementMaskColor(rgb, overlaySVG, fabricCanvas));
            img.onload = null;
          }
          img.src = this.getUgcImgUrl;
        });
      });
    },
    getPlacementURL(placementViewOrder) {
      const { tempData } = this.$store.state.ugc;
      const activeUGCComponent = tempData.features[tempData.activeUGCIndex].activeUGCComponent;
      const assets3d = tempData.features[tempData.activeUGCIndex].responses.assets3d[activeUGCComponent];

      return this.getMultipart > 1 ?
        assets3d.placementGuides[placementViewOrder].url :
        assets3d.placementGuide.url;
    },
    setNewPlacementMaskColor(rgb, overlaySVG, fabricCanvas) {
      this.$store.commit("ugc/stateManager/SET_LOADING", true);
      this.$eventBus.$emit("hide-customs-spinner", false);
      const color = this.$store.state.ugc[`template_guide_outer_bgcolor_${ tinycolor(rgb).isLight() ? 'dark' : 'light' }`];
      this.setColor(color, overlaySVG);

      if (fabricCanvas.getObjects("image")[0] && !this.isSecondPlacement) {
        const img = fabricCanvas.getObjects("image")[0];
        const scaleValue = this.$ugc.getImageScale(overlaySVG, img);
        img.scale(scaleValue);
      }

      if (this.$store.state.ugc.stateManager.activeControl === 'ugc-cropper-control') {
        fabricCanvas.remove(overlaySVG);
        return;
      }

      fabricCanvas.setOverlayImage(overlaySVG, () => {
        // We can either check like the below function for outer_layer
        // or we can set a boolean variable in the pdmi in the UGC placements.
        const outerLayer = overlaySVG.getObjects().find(item => item.id === "outer_layer");
        const placementClone = fabricCanvas.getObjects().find(item => item.id === "placement");
        if(outerLayer && !placementClone) {
          overlaySVG.center();
          outerLayer.opacity = 0;
          const originalPlacement = overlaySVG.getObjects().find(item => item.id === "outer");
          if(originalPlacement) {
            this.cloneOverlay(originalPlacement, fabricCanvas, overlaySVG)
          }
        } else {
          fabricCanvas.renderAll();
          overlaySVG.center();
          fabricCanvas.requestRenderAll();
          this.finishPlacement(overlaySVG);
        }
      });
    },
    cloneOverlay(originalPlacement, fabricCanvas, overlaySVG) {
      originalPlacement.clone((placement) => {
          placement.id = "placement";
          placement.scaleY = this.getPlacementMaskScaleRatio;
          placement.scaleX = this.getPlacementMaskScaleRatio;
          placement.selectable=false;
          placement.evented=false;
          placement.opacity = 0;
          fabricCanvas.add(placement);
          placement.center();
          const placementLocalLeft = originalPlacement.group.left + originalPlacement.left*originalPlacement.group.scaleX + originalPlacement.group.width/2*originalPlacement.group.scaleX;
          const placementLocalTop = originalPlacement.group.top + originalPlacement.top*originalPlacement.group.scaleY + originalPlacement.group.height/2*originalPlacement.group.scaleY;
          overlaySVG.left = overlaySVG.left - (placementLocalLeft - placement.left);
          overlaySVG.top = overlaySVG.top - (placementLocalTop - placement.top);
          fabricCanvas.renderAll();
          fabricCanvas.requestRenderAll();
          this.finishPlacement(overlaySVG)
        });
    },
    finishPlacement(overlaySVG) {
      this.$emit("placement-loaded", overlaySVG);
      this.$eventBus.$emit("placement-loaded");
      this.$store.commit("ugc/stateManager/SET_LOADING", false);
      this.$eventBus.$emit("hide-customs-spinner", true);
      this.$nextTick(()=>{
        document.querySelector("#close-button-newUgcModal").focus();
      });
    },
    setColor(color, overlaySVG) {
      overlaySVG.getObjects().forEach(SVGobjs => {
        SVGPaths.includes(SVGobjs.id) ?
          SVGobjs.opacity = 0 :
          SVGobjs.setColor(color);
      });
    }
  },
  created() {
    this.$eventBus.$on("reload-placement-guide", this.setOverlayImage);
  },
  mounted() {
    this.setOverlayImage();
  },
  beforeDestroy() {
    this.$eventBus.$off("reload-placement-guide", this.setOverlayImage);
  },
  render() {
    return null;
  }
};
</script>
